/*!
 *
 *  widget.ts
 *
 */
import waitTransition from './waitTransition';
export default function () {
    const targets = [
        document.querySelector('#widget'),
        document.querySelector('#cta'),
    ].filter(Boolean);
    if (targets.length === 0)
        return;
    targets.forEach(el => el.classList.add('-init'));
    const elems = targets.map(el => new ToggleWidget(el));
    let threshold = getThreshold();
    const onScroll = () => {
        const y = window.scrollY;
        elems.forEach(el => {
            if (y > threshold) {
                el.show();
            }
            else {
                el.hide();
            }
        });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
        threshold = getThreshold();
    }, { passive: true });
    function getThreshold() {
        if (util.viewport !== 'phone' && util.viewport !== 'tablet') {
            return 210;
        }
        else {
            return 96;
        }
    }
}
class ToggleWidget {
    el;
    cancel;
    isAnimating = false;
    constructor(el) {
        this.el = el;
    }
    show() {
        if (this.el.classList.contains('-visible') && !this.isAnimating)
            return;
        this.cancel?.();
        this.isAnimating = true;
        this.el.hidden = false;
        this.cancel = waitTransition(this.el, 'transform', () => {
            this.isAnimating = false;
            this.cancel = undefined;
        });
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.el.classList.add('-visible');
            });
        });
    }
    hide() {
        if (!this.el.classList.contains('-visible') && !this.isAnimating)
            return;
        this.cancel?.();
        this.isAnimating = true;
        this.cancel = waitTransition(this.el, 'transform', () => {
            this.el.hidden = true;
            this.isAnimating = false;
            this.cancel = undefined;
        });
        requestAnimationFrame(() => {
            this.el.classList.remove('-visible');
        });
    }
}
